<div *ngIf="showAccessDenied" class="access-denied-container">
  <div class="access-denied-content">
    <div style="display: flex; justify-content: center; align-items: center">
      <img class="clickable" src="../../assets/img/new-logo.png" height="60" />
    </div>
    <i class="fas fa-exclamation-triangle"></i>
    <h2>Access Denied</h2>
    <p style="font-weight: bold">
      You are not authorized to access this module.
    </p>
  </div>
</div>
